/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc テキストメッセージ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-card class="fc-text-message" :class="[messageDistributionClass]">
  <div v-html="messageHtmlText"></div>
</el-card>
</template>
<script>
import StringUtil from '@/utils/StringUtil'
import FcMessageUtil from '@/utils/FcMessageUtil'

import {
  Card
} from 'element-ui'

export default {
  name: 'FcTextMessage',
  components: {
    'el-card': Card
  },
  props: [
    /**
     * メッセージ情報
     */
    'messageInfo'
  ],
  data() {
    return {}
  },
  computed: {
    /**
     * メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）を取得します。
     * @return {String} メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）
     */
    messageDistributionClass() {
      return FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * メッセージ内容のHTMLテキストを取得します。
     * @return {String} メッセージ内容のHTMLテキスト
     */
    messageHtmlText() {
      return StringUtil.getHtmlTextMarkUpHttpURL(this.messageInfo.message)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcTextMessage.vue